__turbopack_context__.v({
  "className": "noto_sans_tamil_8e156d8d-module__Ijg5Za__className",
});
